<template>
    <span data-balloon="Click to see the data sheet" data-balloon-pos="up">
        <button class="simple" @click.prevent @click="open" aria-label="Open PDF format file"><i
                class="fa fa-file-pdf-o"></i></button>

        <div class="remodal" :data-remodal-id='modalID'>
            <div class="modal">
                <object :data="result.submittalFile" type="application/pdf" width="100%" height="500px" v-if="active">
                    <p class="meta coach">This browser does not support inline PDFs. Please download the PDF to view it. <a :href="`${result.submittalFile}?&download=1`">Download PDF</a></p>
                </object>
            </div>
            <button data-remodal-action="close" class="remodal-close simple"></button>
        </div>
    </span>
</template>

<script>
    import Modal from 'vue/common/_modal'

    export default {
        computed: {
            modalID() {
                return `${this.item.productId}-show`
            }
        },
        extends: Modal
    }
</script>
